module.exports = __webpack_public_path__ + "img/HuaiyanLiu.c8b9d10c.png";